import { useTranslation } from '@exam-room/translations';

import { DoneIcon, MathRenderer, PaperSection, ReadonlyField } from '../../../../components';

interface QuestionSolutionProps {
  correctAnswer: {
    value: string;
    label: string;
  };
  solution: string;
  reference: string;
  los: string;
}

export default function QuestionSolution(props: Readonly<QuestionSolutionProps>) {
  const { correctAnswer, solution, reference, los } = props;
  const { t } = useTranslation();
  return (
    <PaperSection title={t('examPreview.questionSolution.title')}>
      <div className='flex flex-col gap-4 p-6'>
        <div className='bg-success-300 flex items-center gap-4 rounded-lg p-4'>
          <DoneIcon className='text-success-500 !text-2xl' />
          <p>{correctAnswer.value}.</p>
          <MathRenderer className='w-full' content={correctAnswer.label} />
        </div>
        <hr className='text-border-divider' />
        <ReadonlyField
          label={t('examPreview.questionSolution.explanation')}
          content={<MathRenderer content={solution} />}
        />
        <ReadonlyField
          label={t('examPreview.questionSolution.reference')}
          content={<MathRenderer content={reference} />}
        />
        <ReadonlyField label={t('examPreview.questionSolution.los')} content={los} />
      </div>
    </PaperSection>
  );
}
